export interface Movie {
  id: string
  title: string
  category: 'movie' | 'tv' | 'short'
  genres: string[]
  year: number
  director: string
  cast: string[]
  duration: string
  rating: number
  poster: string
  still: string
  tagline: string
  synopsis: string
  hot: number
  isNew: boolean
  featured: boolean
}

export const categories = [
  { key: 'movie', label: '电影', icon: 'ri-film-line', desc: '完整长片，一次看完的沉浸体验' },
  { key: 'tv', label: '电视剧', icon: 'ri-tv-2-line', desc: '连续剧集，追更不停的多集故事' },
  { key: 'short', label: '短片', icon: 'ri-movie-2-line', desc: '短篇精选，十几分钟的一段心事' },
]

export const genres = ['剧情', '爱情', '悬疑', '犯罪', '古装', '都市', '家庭', '治愈', '传奇']

export const years = [2024, 2023, 2022, 2021]

export const movies: Movie[] = [
  {
    id: 'changan-ye-xing-lu',
    title: '长安夜行录',
    category: 'movie',
    genres: ['古装', '剧情', '悬疑'],
    year: 2024,
    director: '陈牧之',
    cast: ['林清和', '周慕白', '苏晚'],
    duration: '118分钟',
    rating: 8.7,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20artwork%20of%20a%20lone%20figure%20in%20a%20flowing%20dark%20cloak%20walking%20through%20an%20ancient%20Chinese%20city%20street%20at%20night%2C%20warm%20lantern%20glow%20against%20deep%20navy%20shadows%2C%20dramatic%20rim%20light%2C%20fine%20film%20grain%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=poster-changan-night-01&orientation=portrait',
    still:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20ancient%20Chinese%20city%20at%20dusk%2C%20stone%20bridge%20and%20wooden%20lanterns%2C%20a%20solitary%20figure%20in%20a%20dark%20cloak%20seen%20from%20behind%2C%20warm%20amber%20light%20against%20deep%20navy%20blue%20shadows%2C%20atmospheric%20haze%2C%20anamorphic%20composition%2C%20no%20text&width=1280&height=720&seq=still-changan-night-01&orientation=landscape',
    tagline: '一桩旧案，牵出长安城最深的夜。',
    synopsis:
      '长安城入夜后，一桩尘封十年的旧案被重新翻出。负责查案的小吏在灯市与坊墙之间来回奔走，每一条线索都指向同一个沉默的名字。随着夜色渐深，他发现真相并不在马车上，而在那些始终没有开口的人心里。',
    hot: 1,
    isNew: true,
    featured: true,
  },
  {
    id: 'chao-xi-zhi-xia',
    title: '潮汐之夏',
    category: 'movie',
    genres: ['爱情', '剧情'],
    year: 2023,
    director: '何岸',
    cast: ['沈知夏', '江屿', '许南'],
    duration: '104分钟',
    rating: 8.4,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20artwork%20of%20a%20young%20woman%20standing%20on%20a%20windswept%20beach%20at%20golden%20hour%2C%20wet%20sand%20reflections%2C%20deep%20navy%20sea%20and%20warm%20amber%20sky%2C%20backlit%20hair%2C%20fine%20film%20grain%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=poster-tide-summer-02&orientation=portrait',
    still:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20two%20people%20walking%20along%20a%20quiet%20shoreline%20at%20sunset%2C%20long%20shadows%20on%20wet%20sand%2C%20deep%20navy%20ocean%20meeting%20a%20warm%20amber%20horizon%2C%20soft%20sea%20haze%2C%20wide%20anamorphic%20framing%2C%20no%20text&width=1280&height=720&seq=still-tide-summer-02&orientation=landscape',
    tagline: '那年夏天，海水退去后留下了答案。',
    synopsis:
      '海边小城的夏天总是很长。两个在同一个码头长大的人，一个准备离开，一个决定留下。他们在潮水涨落的间隙里反复试探，也在一次意外的台风夜把多年没说的话讲完。潮水退去，沙滩上留下的脚印只有一行。',
    hot: 3,
    isNew: false,
    featured: false,
  },
  {
    id: 'di-qi-feng-xin',
    title: '第七封信',
    category: 'movie',
    genres: ['悬疑', '剧情'],
    year: 2024,
    director: '罗以宁',
    cast: ['顾行舟', '温言', '唐野'],
    duration: '126分钟',
    rating: 8.9,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20artwork%20of%20an%20old%20letter%20and%20a%20brass%20key%20on%20a%20dark%20wooden%20desk%2C%20a%20single%20warm%20lamp%20beam%20cutting%20through%20deep%20navy%20darkness%2C%20dust%20particles%20in%20the%20air%2C%20high%20contrast%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=poster-seventh-letter-03&orientation=portrait',
    still:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20dim%20apartment%20study%20at%20night%2C%20stacked%20letters%20and%20a%20single%20desk%20lamp%2C%20cold%20navy%20shadows%20with%20a%20warm%20amber%20pool%20of%20light%2C%20rain%20on%20the%20window%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=1280&height=720&seq=still-seventh-letter-03&orientation=landscape',
    tagline: '六封信读完了，第七封写给谁？',
    synopsis:
      '整理遗物时，她在旧书柜的夹层里找到六封从未寄出的信。每一封都写着同一个地址，却没有落款。当她按着地址找到那间早已空置的房子，第七封信正安静地躺在门缝里，收信人一栏写着她自己的名字。',
    hot: 2,
    isNew: true,
    featured: true,
  },
  {
    id: 'wu-ye-ni-hong',
    title: '午夜霓虹',
    category: 'movie',
    genres: ['犯罪', '悬疑'],
    year: 2022,
    director: '高崎',
    cast: ['程野', '白鹭', '邵川'],
    duration: '132分钟',
    rating: 8.2,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20artwork%20of%20a%20rain%20soaked%20city%20alley%20at%20midnight%2C%20glowing%20orange%20signage%20reflected%20on%20wet%20asphalt%2C%20a%20silhouette%20in%20a%20long%20coat%2C%20deep%20navy%20shadows%2C%20neon%20haze%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=poster-midnight-neon-04&orientation=portrait',
    still:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20rainy%20downtown%20street%20at%20midnight%2C%20orange%20neon%20reflections%20on%20wet%20pavement%2C%20a%20lone%20figure%20standing%20under%20a%20streetlight%2C%20deep%20navy%20blue%20shadows%2C%20atmospheric%20mist%2C%20no%20text&width=1280&height=720&seq=still-midnight-neon-04&orientation=landscape',
    tagline: '这座城市亮着灯，也藏着人。',
    synopsis:
      '一名夜班出租车司机在同一个路口连续三晚拉到同一位乘客。乘客每次下车的地方都不一样，但留下的纸条内容却越来越像。为了弄清楚这件事，他决定在第四晚跟着对方走一次，却驶进了这座城市从不出现在地图上的角落。',
    hot: 6,
    isNew: false,
    featured: false,
  },
  {
    id: 'hui-jia-de-lu',
    title: '回家的路',
    category: 'movie',
    genres: ['家庭', '剧情'],
    year: 2021,
    director: '沈立',
    cast: ['赵有山', '刘芸', '小满'],
    duration: '111分钟',
    rating: 8.5,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20artwork%20of%20a%20rural%20road%20at%20dawn%20with%20a%20small%20figure%20carrying%20a%20bag%2C%20mist%20over%20fields%2C%20warm%20amber%20sunrise%20against%20deep%20navy%20silhouettes%2C%20gentle%20nostalgic%20mood%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=poster-road-home-05&orientation=portrait',
    still:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20old%20country%20road%20at%20sunrise%2C%20low%20mist%20over%20rice%20fields%2C%20a%20figure%20with%20a%20travel%20bag%20walking%20away%2C%20warm%20amber%20light%20with%20cool%20navy%20shadows%2C%20tender%20atmosphere%2C%20no%20text&width=1280&height=720&seq=still-road-home-05&orientation=landscape',
    tagline: '走了很远，才想起家门口那盏灯。',
    synopsis:
      '在外奔波十二年后，他终于坐上回乡的长途车。村子变了，路也变了，只有母亲还在老屋门口等着。三天的时间里，他重新认识了这座小村，也重新认识了那个总说"不用回来"的人。',
    hot: 9,
    isNew: false,
    featured: false,
  },
  {
    id: 'feng-qi-nan-an',
    title: '风起南岸',
    category: 'tv',
    genres: ['都市', '爱情'],
    year: 2024,
    director: '梁书言',
    cast: ['徐南枝', '陆时', '何清'],
    duration: '全24集',
    rating: 8.6,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20drama%20series%20poster%20artwork%20of%20a%20young%20couple%20on%20a%20rooftop%20overlooking%20a%20coastal%20city%20at%20blue%20hour%2C%20warm%20window%20lights%2C%20deep%20navy%20sky%2C%20wind%20blown%20hair%2C%20film%20grain%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=poster-south-coast-06&orientation=portrait',
    still:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20coastal%20city%20skyline%20at%20blue%20hour%20seen%20from%20a%20rooftop%2C%20warm%20apartment%20lights%20scattered%20across%20deep%20navy%20buildings%2C%20two%20silhouettes%20at%20the%20railing%2C%20soft%20haze%2C%20no%20text&width=1280&height=720&seq=still-south-coast-06&orientation=landscape',
    tagline: '南岸的风，把两个人的计划都吹乱了。',
    synopsis:
      '在南岸做旧城改造的设计师，遇见了坚守祖屋的年轻房东。一个想把街区推向未来，一个想把记忆留在原地。二十四集的拉扯里，两个人和这座城一起长出新的样子。',
    hot: 4,
    isNew: true,
    featured: false,
  },
  {
    id: 'an-yong',
    title: '暗涌',
    category: 'tv',
    genres: ['悬疑', '犯罪'],
    year: 2023,
    director: '韩煜',
    cast: ['顾南', '叶微', '程砚'],
    duration: '全16集',
    rating: 8.8,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20thriller%20series%20poster%20artwork%20of%20a%20detective%20silhouette%20in%20a%20dim%20interrogation%20room%2C%20a%20single%20overhead%20lamp%2C%20deep%20navy%20shadows%20and%20warm%20amber%20highlights%2C%20tension%20in%20the%20air%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=poster-undercurrent-07&orientation=portrait',
    still:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20dim%20police%20archive%20room%20at%20night%2C%20metal%20shelves%20and%20a%20single%20desk%20lamp%2C%20cold%20navy%20shadows%20with%20warm%20amber%20glow%2C%20scattered%20papers%2C%20moody%20thriller%20atmosphere%2C%20no%20text&width=1280&height=720&seq=still-undercurrent-07&orientation=landscape',
    tagline: '水面很静，下面是另一座城。',
    synopsis:
      '港口的水面连着三年风平浪静，直到一只无人认领的集装箱被打开。追查此案的刑警发现，所有经手过这批货的人都在一夜之间改了口供。十六集的追查里，真相像暗涌一样，从最安静的地方浮上来。',
    hot: 5,
    isNew: false,
    featured: true,
  },
  {
    id: 'ka-fei-yu-yu-ji',
    title: '咖啡与雨季',
    category: 'tv',
    genres: ['爱情', '治愈'],
    year: 2022,
    director: '温以宁',
    cast: ['许言', '林小满', '周牧'],
    duration: '全20集',
    rating: 8.1,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20series%20poster%20artwork%20of%20a%20cozy%20corner%20cafe%20on%20a%20rainy%20afternoon%2C%20raindrops%20on%20the%20window%2C%20warm%20amber%20interior%20light%20against%20deep%20navy%20exterior%2C%20two%20coffee%20cups%2C%20soft%20romantic%20mood%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=poster-coffee-rain-08&orientation=portrait',
    still:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20warm%20cafe%20interior%20on%20a%20rainy%20day%2C%20raindrops%20blurred%20on%20large%20windows%2C%20two%20cups%20on%20a%20wooden%20table%2C%20amber%20lamps%20and%20deep%20navy%20shadows%20outside%2C%20cozy%20cinematic%20mood%2C%20no%20text&width=1280&height=720&seq=still-coffee-rain-08&orientation=landscape',
    tagline: '雨季开始的那天，她多煮了一杯咖啡。',
    synopsis:
      '街角的咖啡馆只在雨天营业。店主有个奇怪的习惯，每天都会多煮一杯咖啡放在窗边。直到某个连绵不断的雨季，那杯咖啡终于等来了它的主人，也带来了一段慢下来的关系。',
    hot: 8,
    isNew: false,
    featured: false,
  },
  {
    id: 'shan-he-jiu-meng',
    title: '山河旧梦',
    category: 'tv',
    genres: ['古装', '传奇'],
    year: 2023,
    director: '张牧川',
    cast: ['萧承', '柳如烟', '谢无咎'],
    duration: '全36集',
    rating: 8.3,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20costume%20epic%20poster%20artwork%20of%20a%20mountain%20fortress%20under%20storm%20clouds%2C%20banners%20in%20the%20wind%2C%20a%20general%20in%20dark%20armor%20seen%20from%20behind%2C%20warm%20amber%20torchlight%20against%20deep%20navy%20sky%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=poster-mountain-dream-09&orientation=portrait',
    still:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20ancient%20mountain%20fortress%20at%20dusk%2C%20stone%20walls%20and%20fluttering%20banners%2C%20torchlight%20glowing%20warm%20amber%20against%20deep%20navy%20storm%20clouds%2C%20sweeping%20epic%20scale%2C%20no%20text&width=1280&height=720&seq=still-mountain-dream-09&orientation=landscape',
    tagline: '山河未改，故人已远。',
    synopsis:
      '边关守将奉命回京述职，却在半途接到一道没有署名的调令。三十六集的篇幅里，他在朝堂与战场之间两难，而当年一起立誓的三个人，已经站在了不同的城墙上。',
    hot: 7,
    isNew: false,
    featured: false,
  },
  {
    id: 'yi-gong-li-de-chun-tian',
    title: '一公里的春天',
    category: 'short',
    genres: ['爱情', '治愈'],
    year: 2024,
    director: '田禾',
    cast: ['沈鹿', '陈屿'],
    duration: '18分钟',
    rating: 8.0,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20poster%20artwork%20of%20a%20girl%20on%20a%20bicycle%20waiting%20at%20a%20crosswalk%20in%20early%20spring%2C%20blooming%20branches%2C%20warm%20amber%20sunlight%20and%20deep%20navy%20shadows%2C%20tender%20minimal%20mood%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=poster-spring-mile-10&orientation=portrait',
    still:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20quiet%20spring%20street%20with%20blooming%20branches%2C%20a%20bicycle%20leaning%20by%20the%20curb%2C%20warm%20amber%20afternoon%20light%20and%20soft%20navy%20shadows%2C%20gentle%20intimate%20framing%2C%20no%20text&width=1280&height=720&seq=still-spring-mile-10&orientation=landscape',
    tagline: '从地铁站到家，刚好一公里。',
    synopsis:
      '每天下班，她都会在同一段路上遇见那个推着自行车的男生。一公里的距离，两个人走了整整一个春天。直到某天路口开始施工，他们必须选择绕远，还是第一次并肩走完这段路。',
    hot: 10,
    isNew: true,
    featured: false,
  },
  {
    id: 'dian-ti-jian',
    title: '电梯间',
    category: 'short',
    genres: ['悬疑', '剧情'],
    year: 2023,
    director: '郑迟',
    cast: ['余默', '秦昭'],
    duration: '22分钟',
    rating: 7.9,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20poster%20artwork%20of%20a%20narrow%20elevator%20interior%2C%20flickering%20warm%20amber%20light%20above%2C%20deep%20navy%20shadows%20in%20the%20corners%2C%20mirrored%20walls%2C%20unsettling%20atmosphere%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=poster-elevator-11&orientation=portrait',
    still:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20inside%20a%20narrow%20elevator%20with%20mirrored%20walls%2C%20flickering%20amber%20overhead%20light%2C%20deep%20navy%20shadows%20and%20reflective%20surfaces%2C%20uneasy%20thriller%20mood%2C%20symmetrical%20framing%2C%20no%20text&width=1280&height=720&seq=still-elevator-11&orientation=landscape',
    tagline: '电梯停在十三层，门却没有开。',
    synopsis:
      '深夜加班后，他走进一部老电梯。电梯在十三层停下，门却没有打开，楼层显示开始倒退。二十二分钟里，他和一个陌生女人被困在这个狭小空间，也逐渐发现彼此并不陌生。',
    hot: 11,
    isNew: false,
    featured: false,
  },
  {
    id: 'wan-feng-xin-xiang',
    title: '晚风信箱',
    category: 'short',
    genres: ['剧情', '治愈'],
    year: 2022,
    director: '苏禾',
    cast: ['顾晚', '宋清'],
    duration: '26分钟',
    rating: 8.2,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20poster%20artwork%20of%20an%20old%20green%20mailbox%20by%20a%20seaside%20wall%20at%20evening%2C%20a%20handwritten%20letter%20in%20hand%2C%20warm%20amber%20dusk%20and%20deep%20navy%20sea%2C%20nostalgic%20mood%2C%20portrait%20composition%2C%20no%20text&width=600&height=800&seq=poster-evening-mailbox-12&orientation=portrait',
    still:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20old%20mailbox%20beside%20a%20seaside%20stone%20wall%20at%20dusk%2C%20a%20hand%20holding%20a%20letter%2C%20warm%20amber%20light%20and%20deep%20navy%20ocean%2C%20soft%20breeze%20and%20nostalgic%20mood%2C%20no%20text&width=1280&height=720&seq=still-evening-mailbox-12&orientation=landscape',
    tagline: '有些话写下来，才追得上晚风。',
    synopsis:
      '海边的旧信箱早就不再收信，却总有人往里放东西。一位常来散步的老人和刚搬来的年轻人，因为一封被风吹落的信认识，也慢慢把各自没说出口的往事讲给了对方。',
    hot: 12,
    isNew: false,
    featured: false,
  },
]